<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <div>
      <!-- title  -->
      <h2 class="mb-1">{{ $t('Peržiūra') }}</h2>
      <v-row class="mb-0 pb-0">
        <v-col v-if="showPdfFile" class="pb-0" cols="12" md="12">
          <el-PDF-viewer download :file="pdfFile" />
        </v-col>
      </v-row>
       <v-row no-gutters>
          <v-spacer></v-spacer>
          <el-button
            tile
            @click.native="goBack()"
            :loading="loading"
            title="Atgal"
          />
        </v-row>
    </div>
  </v-container>
</template>

<script>
import errorNotifications from '@/mixins/errorNotifications'
import math from '@/mixins/math'

export default {
  name: 'OrderView',
  components: {},
  mixins: [errorNotifications, math],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      pdfFile: {},
    }
  },
  computed: {
    showPdfFile() {
      return this.pdfFile && Object.keys(this.pdfFile).length != 0
    },
    getId() {
      return this.$route.params.id || null
    },
  },
  created() {
    this.getUploadId()
  },
  methods: {
    goBack(){
      const url = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}services.do?showValidOnly=true&persist=new`
      window.location.href = url
      // window.history.back();
    },
    getUploadId(){
      this.pageloading = true
      this.$axios
        .get(`statement-orders/${this.getId}`)
        .then((res) => {
          if(res.data.statementOrder.upload_id){
            this.getPdfFile(res.data.statementOrder.upload_id)
          } else {
            return this.$router.push({ name: 'sav404' })
          }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    getPdfFile(id) {
      this.pageloading = true
      this.$axios
        .get(`uploads/${id}/download`)
        .then((res) => {
          this.pdfFile = res.data
        })
        .catch((err) => {
          if (err.response.status === 404) {
            return this.$router.push({ name: 'sav404' })
          } else {
            this.$root.$emit('DATA_ERROR', err.response.data.message)
          }
        })
        .finally(() => {
          this.pageloading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped></style>
